import { mapState } from 'vuex';

export default {
  data() {
    return {
      listLaporan: [
        {
          laporan_id: 'pendampingan',
          key: 'download',
          label: `Daftar Laporan Sekolah`,
          acl: this.$allow(`psp-peserta-kp.download`),
          params: {},
        },
        {
          laporan_id: 'sekolah',
          key: 'download',
          label: `Daftar Laporan Pendampingan`,
          acl: this.$allow(`psp-peserta-kp.download`),
          params: { k_laporan: 'pendampingan' },
        },
        {
          laporan_id: 'umum',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Umum`,
          acl: this.$allow(`psp-peserta-kp.download-pendampingan`),
          params: { k_laporan: 'umum' },
        },
        {
          laporan_id: 'sdm',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - SDM`,
          acl: this.$allow(`psp-peserta-kp.download-pendampingan`),
          params: { k_laporan: 'sdm' },
        },
        {
          laporan_id: 'anggaran',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Anggaran`,
          acl: this.$allow(`psp-peserta-kp.download-pendampingan`),
          params: { k_laporan: 'anggaran' },
        },
        {
          laporan_id: 'teknologi',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Teknologi`,
          acl: this.$allow(`psp-peserta-kp.download-pendampingan`),
          params: { k_laporan: 'teknologi' },
        },
        {
          laporan_id: 'kegiatan-pembelajaran',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Kegiatan Pembelajaran`,
          acl: this.$allow(`psp-peserta-kp.download-pendampingan`),
          params: { k_laporan: 'kegiatan-pembelajaran' },
        },
        {
          laporan_id: 'dukungan-pemda',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Dukungan Pemerintah Daerah`,
          acl: this.$allow(`psp-peserta-kp.download-pendampingan`),
          params: { k_laporan: 'dukungan-pemda' },
        },
        {
          laporan_id: 'dukungan-sekolah',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Dukungan Internal Sekolah`,
          acl: this.$allow(`psp-peserta-kp.download-pendampingan`),
          params: { k_laporan: 'dukungan-sekolah' },
        },
        {
          laporan_id: 'kondisi-mendesak',
          key: 'download-pendampingan',
          label: `Laporan Pendamping IN-PA - Kondisi Mendesak`,
          acl: this.$allow(`psp-peserta-kp.download-pendampingan`),
          params: { k_laporan: 'kondisi-mendesak' },
        },
      ],
    };
  },
  computed: {
    ...mapState('preferensi', {
      preferensi: (state) => state.data,
    }),

    api() {
      return this.$route.meta.api || 'kp';
    },

    isViewLaporan() {
      return this.$route.meta.view || false;
    },

    akunId() {
      return this.$getDeepObj(this, 'preferensi.akun.akun_id');
    },

    allowDownload() {
      return this.listLaporan.filter((item) => this.$allow(item.acl)).length > 0;
    },
  },
  methods: {
    onDetail(item) {
      this.$router.push({
        name: this.api === 'kp' ? 'detail-diklat-pendampingan' : 'detail-pendampingan',
        params: { detail_id: item.psp_kp_id },
      });
    },

    onAdd() {
      this.$set(this.formulir, 'form', 'FormKelompok');
      this.$set(this.formulir, 'title', 'Tambah Kelompok Pendampingan KP');
      this.$set(this.formulir, 'id', null);

      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', null);
      });
    },

    async onEdit(item) {
      this.$set(this.formulir, 'form', 'FormKelompok');
      this.$set(this.formulir, 'title', 'Ubah Kelompok Pendampingan KP');
      this.$set(this.formulir, 'id', item.psp_kp_id);
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'useSave', true);
      const data = await this.getDetail({ id: item.psp_kp_id, api: this.api });

      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', data);
      });
    },

    onEditPendampingan(kPendampingan) {
      const pendampingan = this.$getDeepObj(this, `pendampingans.${kPendampingan}`) || null;
      this.$set(this.formulir, 'form', 'FormPendampingan');
      this.$set(this.formulir, 'title', `Jadwal Pertemuan ke ${kPendampingan}`);
      this.$set(this.formulir, 'id', kPendampingan);
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'useSave', true);
      this.$set(this.formulir, 'pendampingan_id', (pendampingan && pendampingan.psp_kp_pendampingan_id) || null);

      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', pendampingan);
        clearInterval(this.autosave);
      });
    },

    async onKuisioner(item) {
      const pendampingan = this.$getDeepObj(this, `pendampingans.${this.kPertemuan}`) || null;
      this.$store.commit('SET_AUTOSAVE', false);

      const resp = await this.getInstrument({
        id: this.$getDeepObj(pendampingan, 'psp_kp_pendampingan_id'),
        sekolah_id: this.$getDeepObj(item, 'psp_kp_sekolah_id'),
      });

      this.$set(this.formulir, 'form', 'FormKuisioner');
      this.$set(this.formulir, 'title', `Jadwal ${this.kPertemuan} - Laporan Kuisioner Sekolah`);
      this.$set(this.formulir, 'id', this.$getDeepObj(pendampingan, 'psp_kp_pendampingan_id'));
      this.$set(this.formulir, 'sekolah_id', this.$getDeepObj(item, 'psp_kp_sekolah_id'));
      this.$set(this.formulir, 'isPreview', !this.$allow('psp-peserta-pendampingan.update-laporan'));
      this.$set(this.formulir, 'useSave', this.$allow('psp-peserta-pendampingan.update-laporan'));
      this.$set(this.formulir, 'init', null);

      const init = {
        sekolah: item,
        formulir: (resp && resp.data) || [],
      };

      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', init);
        clearInterval(this.autosave);
        this.onSetAutoSave();
      });
    },

    onSave() {
      this.save();
    },

    save(isAutosave = false) {
      const item = this.$refs.formulir.getValue();
      const form = (item && item.form) || {};
      const kBelajarPsp = (item && item.k_belajar_psp) || {};
      const id = this.formulir.id;
      const validate = this.$refs.formulir.validate();

      if (!validate) {
        this.$refs.modal.loading = false;
        return;
      }

      // auto save tanpa loading
      if (this.$refs?.modal) this.$refs.modal.loading = !isAutosave;
      this.$store.commit('SET_AUTOSAVE', isAutosave);

      if (this.formulir.form === 'FormPendampingan') {
        this.savePendampingan(id, form);
        return;
      } else if (this.formulir.form === 'FormKuisioner') {
        this.saveKuisioner(id, { form, kBelajarPsp }, isAutosave);
        return;
      }

      this[id ? 'update' : 'create']({ id: id, params: form })
        .then(() => {
          this.$success(`Data kelompok berhasil di${id ? 'update' : 'tambahkan'}`);
          this.$refs.modal.close();
          if (this.id) {
            this.getPendampingan();
          } else {
            this.onReload();
          }
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    savePendampingan(id, form) {
      const formData = new FormData();
      const formId =
        this.api === 'kp'
          ? this.$getDeepObj(this.detail, 'psp_kp_id')
          : this.$getDeepObj(this.formulir, 'pendampingan_id');

      Object.keys(form).forEach((key) => {
        if (this.$isArray(form[key])) {
          (form[key] || []).forEach((item, index) => {
            Object.keys(item).forEach((i) => {
              if (item[i]) {
                formData.append(`data_meeting[${index}][${i}]`, item[i] || '');
              }
            });
          });
        } else {
          formData.append(key, form[key]);
        }
      });

      this.updatePendampingan({ id: formId, params: formData })
        .then(() => {
          this.$success('Data pendampingan berhasil di update');
          this.getPendampingan();
          this.$refs.modal.close();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    saveKuisioner(id, params = {}, autoSave = false) {
      if (!this.$allow('psp-peserta-pendampingan.update-laporan')) return;
      if (!Object.keys(params && params.form).length) return;

      const { form, kBelajarPsp } = params;
      const formData = new FormData();
      formData.append('autosave', autoSave ? 1 : 0);
      formData.append('k_belajar_psp', kBelajarPsp);
      form.forEach((item, index) => {
        Object.keys(item).forEach((s) => {
          formData.append(`instrumen[${index}][${s}]`, item[s]);
        });
      });

      this.updateLaporan({
        id: id,
        sekolah_id: this.$getDeepObj(this.formulir, 'sekolah_id'),
        params: formData,
      })
        .then(() => {
          if (!autoSave) {
            this.$success('Data laporan berhasil di update');
            this.getSekolahPendampingan(this.kPertemuan);
            this.$refs.modal.close();
            clearInterval(this.autosave);
          }
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onDelete(item) {
      this.$confirm(
        `<span class="black--text">Anda yakin ingin menghapus data pendampingan <strong>${item.nama ||
          '-'}</strong> ?</span>`,
        `Hapus Pendampingan`,
        {
          tipe: 'error',
          data: '',
        }
      ).then(() => {
        this.delete({ id: item.psp_kp_id }).then(() => {
          this.$success('Data pendampingan berhasil di hapus');
          this.onReload();
        });
      });
    },

    getPendampingan() {
      if (!this.id) return;
      this.getDetail({ id: this.id, api: this.api })
        .then((resp) => {
          this.detail = resp || {};
        })
        .then(() => {
          if (this.api === 'pendampingan') {
            const pendampingan =
              (this.$getDeepObj(this.detail, 'psp_kp_pendampingans.data') || []).filter(
                (s) => Number(s.instruktur_id) === Number(this.akunId)
              ) || [];
            this.kPertemuan = (pendampingan[0] && pendampingan[0]['pendampingan_ke']) || 1;
          }
        })
        .then(() => {
          this.getSekolahPendampingan(this.kPertemuan || 1);
        })
        .then(() => {
          if (this.isViewLaporan) return;
          this.getPic().then(({ data }) => {
            this.masters = data;
          });
        });
    },

    getLastPendampingan(item) {
      let obj = this.$getDeepObj(item, 'psp_kp_pendampingans.data') || [];
      if (this.api === 'pendampingan') {
        obj = obj.filter((s) => Number(s.instruktur_id) === Number(this.akunId)) || [];
        return obj;
      }

      const pendampingan = this.$arrToObj(obj, 'pendampingan_ke');
      if (!Object.keys(pendampingan).length) return false;
      let index = 0;
      for (let i = 4; i > 0; i--) {
        if (pendampingan[i]) {
          index = i;
          break;
        }
      }

      return (pendampingan && pendampingan[index]) || {};
    },

    onDownloadList() {
      let url = {};
      this.$confirm('Pilih jenis Berkas yang ingin di Unduh?', 'Unduh Berkas', {
        tipe: 'info',
        icon: 'mdi-download',
        form: {
          desc: 'Laporan Berkas',
          render: (h) => {
            return h(
              'select',
              {
                class: 'custom-select',
                domProps: {
                  value: '',
                },
                on: {
                  input: function(event) {
                    url.dokumen = event.target.value;
                  },
                },
              },
              [
                h('option', { attrs: { value: '' } }, '-- Pilih Laporan Berkas --'),
                this.listLaporan
                  .filter((laporan) => this.$allow(laporan.acl))
                  .map((item) => h('option', { attrs: { value: item.laporan_id } }, item.label)),
              ]
            );
          },
        },
        lblConfirmButton: 'Unduh',
      }).then(() => {
        if (!url.dokumen) {
          this.$error('Silakan pilih laporan yang ingin diunduh!');
          return;
        }

        const laporan = this.listLaporan.find((item) => item.laporan_id === url.dokumen) || {};

        const params = Object.assign({}, laporan.params);
        this.downloadList({ params, url: laporan.key }).then((url) => {
          this.$downloadFile(url);
        });
      });
    },

    onSetAutoSave() {
      this.autosave = setInterval(() => {
        this.save(true);
      }, 3 * 60 * 1000);
    },

    onCloseModal() {
      clearInterval(this.autosave);
      if (this.$refs?.modal) this.$refs.modal.dialog = false;
    },
  },
};
